import {
    RequestIdWithWarning,
    replaceRequestId,
} from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';
import { OfficeRequest } from '../../components/utilities/Table/generalColumns/RegionalRequest';
import { ClientIdentification } from '../../components/utilities/Table/generalColumns/ClientIdentification';
import { ExecutiveWithTooltip } from '../../components/utilities/Table/generalColumns/ExecutiveWithTooltip';
import { StatusWithTooltip } from '../../components/utilities/Table/generalColumns/StatusWithTooltip';
import { CausalRequest } from '../../components/utilities/Table/generalColumns/CausalRequest';
import { AmountRequest } from '../../components/utilities/Table/generalColumns/AmountRequest';
import { ConsultMonitoring } from '../../components/utilities/Table/MonitoringConsult';

const commonColumns = [
    RequestIdWithWarning('gestionsolicitud.fecha_mesa'),
    {
        Header: 'Producto',
        accessor: 'subproducto.label',
    },
    OfficeRequest,
    ClientIdentification,
    {
        Header: 'Cliente',
        accessor: 'persona.full_name',
        typeId: 'HeaderClient',
    },
    ExecutiveWithTooltip,
    AmountRequest,
    {
        Header: 'Plazo',
        accessor: 'plazo_solicitado',
    },
    
];

const requestsListStatus = [
    {
        id: 'asignadas_director_regional',
        label: 'EJECUTIVO',
        status: '20',
        responsable: null,
        offices: true,
        columns: (() => {
            const cols = [...commonColumns];
            cols.splice(1, 0, {
                Header: 'Fecha Creación',
                accessor: 'gestionsolicitud.fecha_creacion',
            });
            cols.splice(11, 0, ConsultMonitoring);

            return cols;
        })(),
        buttonAction: [{ name: 'reassingUserRequest' }],
        registrationLimit: 25, // limit for registration in list credits
    },
    {
        id: 'tramitadas_director_regional',
        label: 'TRAMITADAS',
        status: '30,40',
        responsable: null,
        offices: true,
        columns: (() => {
            const cols = [...replaceRequestId(commonColumns)];
            cols.splice(1, 0, {
                Header: 'Fecha Ejecutivo',
                accessor: 'gestionsolicitud.fecha_ejecutivo',
            });
            cols.splice(9, 0, StatusWithTooltip);

            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'aprobadas_director_regional',
        label: 'APROBADAS',
        status: '50,60',
        responsable: null,
        offices: true,
        columns: (() => {
            const cols = [...replaceRequestId(commonColumns)];
            cols.splice(1, 0, {
                Header: 'Fecha Aprobación',
                accessor: 'gestionsolicitud.fecha_comite',
            });
            cols.splice(10, 0, StatusWithTooltip);
            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },

    {
        id: 'desembolsadas_director_regional',
        label: 'DESEMBOLSADAS',
        status: '90',
        responsable: null,
        offices: true,
        columns: (() => {
            const cols = [...replaceRequestId(commonColumns)];
            cols.splice(1, 0, {
                Header: 'Fecha Desembolso',
                accessor: 'gestionsolicitud.fecha_desembolso',
            });
            cols.splice(10, 0, StatusWithTooltip);

            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'desistidas_director_regional',
        label: 'DESISTIDAS',
        status: '80',
        responsable: null,
        offices: true,
        columns: (() => {
            const cols = [
                ...replaceRequestId(commonColumns.concat([CausalRequest])),
            ];
            cols.splice(1, 0, {
                Header: 'Fecha Desistimiento',
                accessor: 'gestionsolicitud.fecha_desistimiento',
            });
            cols.splice(10, 0, StatusWithTooltip);
            return cols;
        })(),
        buttonAction: [{ name: 'resumeStatusRequest' }],
        registrationLimit: 5, // limit for registration in list credits
    },
    {
        id: 'rechazadas_director_regional',
        label: 'RECHAZADAS',
        status: '70',
        responsable: null,
        offices: true,
        columns: (() => {
            const cols = [
                ...replaceRequestId(commonColumns.concat([CausalRequest])),
            ];
            cols.splice(1, 0, {
                Header: 'Fecha Rechazo',
                accessor: 'gestionsolicitud.fecha_rechazo',
            });
            cols.splice(10, 0, StatusWithTooltip);
            return cols;
        })(),
        registrationLimit: 5, // limit for registration in list credits
    },
];

export default requestsListStatus;
